import { ChangeDetectionStrategy, Component } from '@angular/core';

// Fila "check + texto" usada en listas de beneficios/características/requisitos de una oferta.
@Component({
  selector: 'app-ui-check-list-item',
  template: `
    <div class="ui-check-list-item">
      <i class="fa fa-check" aria-hidden="true"></i>
      <p><ng-content /></p>
    </div>
  `,
  styleUrl: './ui-check-list-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCheckListItemAtomComponent {}
